import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const Heapandavltree = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Heaps and AVL tree"
    videos={[
      "https://www.youtube.com/embed/HqPJF2L5h9U",
      "https://www.youtube.com/embed/jDM6_TnYIqE"
    ]}
    takeaways={[]}
    questions={[]}
    exampleVideos={[]}
  />
);
}

export default Heapandavltree;
